import React from 'react'
import { Link } from 'react-router-dom'
import Flag from '../common/Flag'

export default function Header({ showTickerExtras, competition, message }) {
  return (
    <header className="mb-6">
      <nav className="px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
          <img src="/images/berkutschi-logo.png" alt="Berkutschi Live" className="h-16" />
        </Link>

        {/* Competition Info */}
        {showTickerExtras && competition && (
          <div className="flex items-center gap-4">
            {/* Hill Image */}
            {competition.hill?.hill_images?.[0]?.hill_thumb && (
              <img 
                src={competition.hill.hill_images[0].hill_thumb} 
                alt="Hill" 
                className="hidden md:block w-16 h-16 object-cover rounded-lg shadow-sm"
              />
            )}
            
            <div className="text-right">
              {/* Location and Nation */}
              <div className="flex items-center justify-end gap-2 mb-1">
                <span className="text-base md:text-lg font-bold text-gray-900">
                  {competition.hill?.location?.name}
                </span>
                <Flag code={competition.hill?.location?.nation?.shortname} className="text-lg" />
              </div>
              
              {/* Competition Type and Hill Details */}
              <div className="text-xs md:text-sm text-gray-600 space-x-3">
                <span className="font-semibold text-gray-900">
                  {competition.sorts?.includes('SGP') && 'Grand Prix'}
                  {competition.sorts?.includes('WC') && 'World Cup'}
                  {competition.sorts?.includes('COC') && 'Continental Cup'}
                  {competition.sorts?.includes('WM') && 'World Championships'}
                  {competition.sorts?.includes('OG') && 'Olympic Games'}
                </span>
                <span>
                  {competition.gender === 'M' && 'Men'}
                  {competition.gender === 'L' && 'Ladies'}
                  {competition.gender === 'ML' && 'Mixed'}
                  {competition.team === 1 && ' / Team'}
                </span>
                <span>•</span>
                <span>K{competition.hill?.point_k ? Number(competition.hill.point_k).toFixed(0) : 'N/A'}</span>
                <span>•</span>
                <span>HS{competition.hill?.hill_size ? Number(competition.hill.hill_size).toFixed(0) : 'N/A'}</span>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Message Banner - always mounted so its height never pops the page around */}
      <div
        className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 text-white px-4 py-1.5 text-center text-sm font-medium"
        role="status"
        aria-live="polite"
      >
        <div className="flex items-center justify-center space-x-2">
          <svg className="w-3.5 h-3.5 flex-shrink-0 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <span>{message || 'Live Results'}</span>
        </div>
      </div>
    </header>
  )
}
